import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

// Attach JWT from localStorage to every request
client.interceptors.request.use((config) => {
  const token = localStorage.getItem("wh_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const getProducts = () => client.get("/products").then((r) => r.data);
export const getProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);
export const createConsultation = (payload) =>
  client.post("/consultations", payload).then((r) => r.data);
export const analyzeSkin = (payload) =>
  client.post("/skin-analysis", payload).then((r) => r.data);
export const createCheckout = (payload) =>
  client.post("/payments/checkout", payload).then((r) => r.data);
export const getPaymentStatus = (sessionId) =>
  client.get(`/payments/status/${sessionId}`).then((r) => r.data);

// Auth
export const register = (payload) => client.post("/auth/register", payload).then((r) => r.data);
export const login = (payload) => client.post("/auth/login", payload).then((r) => r.data);
export const getMe = () => client.get("/auth/me").then((r) => r.data);
export const changePassword = (payload) => client.post("/auth/change-password", payload).then((r) => r.data);
export const forgotPassword = (payload) => client.post("/auth/forgot-password", payload).then((r) => r.data);
export const resetPassword = (payload) => client.post("/auth/reset-password", payload).then((r) => r.data);

// Instagram
export const getInstagramLinks = () => client.get("/instagram-links").then((r) => r.data);
export const setInstagramLinks = (payload) => client.put("/admin/instagram-links", payload).then((r) => r.data);

// Loyalty
export const getLoyaltyRewards = () => client.get("/admin/loyalty-rewards").then((r) => r.data);

// Admin schedule (calendar view)
export const getSchedule = () => client.get("/admin/schedule").then((r) => r.data);

// Client
export const bookAppointment = (payload) => client.post("/appointments", payload).then((r) => r.data);
export const getMyDashboard = () => client.get("/me/dashboard").then((r) => r.data);

// Admin
export const getClients = () => client.get("/admin/clients").then((r) => r.data);
export const getClientDetail = (id) => client.get(`/admin/clients/${id}`).then((r) => r.data);
export const getAllAppointments = () => client.get("/admin/appointments").then((r) => r.data);
export const updateAppointment = (id, status) =>
  client.patch(`/admin/appointments/${id}`, { status }).then((r) => r.data);
export const createAdminAppointment = (payload) =>
  client.post("/admin/appointments", payload).then((r) => r.data);
export const addNote = (payload) => client.post("/admin/notes", payload).then((r) => r.data);
export const getOrders = () => client.get("/admin/orders").then((r) => r.data);
export const updateOrder = (sessionId, status) =>
  client.patch(`/admin/orders/${sessionId}`, { status }).then((r) => r.data);
export const resyncCatalog = (markup_percent) =>
  client.post("/admin/resync-catalog", { markup_percent }).then((r) => r.data);
export const getCatalogStatus = () => client.get("/admin/catalog-status").then((r) => r.data);

export default client;
